import * as React from "react"

const NoLinks = (props) => (
  <svg
    width={390}
    height={274}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M322.954 111.746c-5.017-1.737-8.445-4.751-12.311-9.165l1.635-3.484c4.057 5.374 5.388 8.282 10.459 7.862l.217 4.787Z"
        fill="#FFB900"
      />
      <path
        d="M380.549 188.935c-3.732-4.855-5.398-9.839-6.782-16.384l3.181-2.112c1.095 7.546.896 11.066 5.724 13.988l-2.123 4.508Z"
        fill="#007BFF"
      />
      <path
        d="M255.548 124.855c-5.283 1.313-9.674.56-15.06-1.213l-.01-4.094c5.971 2.528 8.419 4.397 12.827 1.102l2.243 4.205Z"
        fill="#14CCA1"
      />
      <path
        d="M119.753 108.204c-2.498 3.552-5.302 5.45-9.077 7.293l-1.621-2.331c4.406-1.723 6.541-1.954 7.756-6.173l2.942 1.211Z"
        fill="#FF5C33"
      />
      <path
        d="M32.871 211.548c-5.934.298-10.375-1.343-15.598-4.223l1.076-4.192c5.64 3.769 7.732 6.166 13.267 3.666l1.255 4.749Z"
        fill="#007BFF"
      />
      <path
        d="M43.69 109.831c-4.527-3.29-6.897-7.324-9.164-12.868l3.081-2.886c2.09 6.542 2.317 9.806 7.757 11.006l-1.674 4.748Z"
        fill="#14CCA1"
      />
      <path
        d="M70.777 146.135c-5.13 3.582-9.97 4.623-16.166 5.012l-1.28-4.287c7.044.16 10.19 1.096 13.789-4.199l3.657 3.474Z"
        fill="#007BFF"
      />
      <path
        d="M144.23 47.367c-5.144 3.026-9.855 3.636-15.832 3.508l-.974-4.223c6.758.723 9.726 1.879 13.502-2.918l3.304 3.633Z"
        fill="#FFB900"
      />
      <path
        d="M217.142 57.801c-4.288-2.115-7.061-5.177-10.1-9.53l1.746-2.892c3.127 5.221 4.054 7.948 8.573 8.163l-.219 4.26Z"
        fill="#14CCA1"
      />
      <path
        d="M283.895 74.538c4.693-2.765 7.296-6.373 9.894-11.4l-2.871-2.915c-2.483 5.974-2.916 9.012-8.379 9.757l1.356 4.558Z"
        fill="#FF5C33"
      />
      <path
        opacity={0.837}
        d="M129.403 223.043c-4.73-2.819-7.672-6.567-10.821-11.81l2.193-3.126c3.189 6.243 4.049 9.436 9.18 10.111l-.552 4.825Z"
        fill="#FF5C33"
      />
      <path
        d="M285.881 180.64c-1.883 5.864-4.791 9.751-8.971 14.059l-2.98-2.189c5.045-4.474 7.716-5.862 7.688-11.938l4.263.068ZM91.605 85.565a1.992 1.992 0 1 0 0-3.983 1.992 1.992 0 0 0 0 3.983Z"
        fill="#FF5C33"
      />
      <path
        d="M249.885 85.565a1.992 1.992 0 1 0 0-3.984 1.992 1.992 0 0 0 0 3.984Z"
        fill="#FFB900"
      />
      <path
        d="M301.939 146.255a1.992 1.992 0 1 0 0-3.984 1.992 1.992 0 0 0 0 3.984Z"
        fill="#FF5C33"
      />
      <path
        d="M94.792 166.439a1.992 1.992 0 1 0 0-3.984 1.992 1.992 0 0 0 0 3.984Z"
        fill="#14CCA1"
      />
      <path
        d="M3.982 143 0 146.983l3.982 3.984 3.983-3.984L3.982 143Z"
        fill="#FFB900"
      />
      <path
        d="m349.906 136.477-3.983 3.984 3.983 3.983 3.983-3.983-3.983-3.984Z"
        fill="#14CCA1"
      />
    </g>
    <path
      opacity={0.45}
      d="M104.758 243.001c28.593 0 51.773-4.359 51.773-9.737s-23.18-9.738-51.773-9.738c-28.594 0-51.773 4.36-51.773 9.738 0 5.378 23.18 9.737 51.773 9.737Z"
      fill="#E6E6E6"
    />
    <path d="M298.184 69.848H107.287v124.575h190.897V69.848Z" fill="#E6E6E6" />
    <path
      d="M116.517 81.217c1.724 0 3.122-1.388 3.122-3.1 0-1.713-1.398-3.101-3.122-3.101-1.725 0-3.123 1.388-3.123 3.1 0 1.713 1.398 3.101 3.123 3.101Z"
      fill="#24285B"
    />
    <path
      d="M125.793 81.217c1.724 0 3.122-1.388 3.122-3.1 0-1.713-1.398-3.101-3.122-3.101-1.725 0-3.123 1.388-3.123 3.1 0 1.713 1.398 3.101 3.123 3.101Z"
      fill="#007AFF"
    />
    <path
      d="M134.539 81.217c1.724 0 3.122-1.388 3.122-3.1 0-1.713-1.398-3.101-3.122-3.101-1.725 0-3.122 1.388-3.122 3.1 0 1.713 1.397 3.101 3.122 3.101Z"
      fill="#FFD200"
    />
    <path
      opacity={0.08}
      d="m267.244 69.848-44.963.181-7.194 10.055-67.786 61.825 5.569 10.744-19.035 7.453h-18.551l-2.456 34.317h21.692l3.067-20.037c18.159-2.403 30.128-18.931 30.128-18.931l79.097-33.592-10.042-22.975 13.356-6.346.74 4.161s7.221-1.976 6.92-8.658c-.301-6.683-.931-14.978 9.458-18.197Z"
      fill="#000"
    />
    <path
      d="M230.142 44.525c-1.104 8.785-5.669 26.937-24.412 35.024l2.739 4.533s26.083-8.16 32.373-29.013c2.821-9.383 1.023-13.454-1.826-15.105a6.038 6.038 0 0 0-7.854 1.844 5.942 5.942 0 0 0-1.02 2.717Z"
      fill="#007AFF"
    />
    <path
      opacity={0.2}
      d="M230.142 44.525c-1.104 8.785-5.669 26.937-24.412 35.024l2.739 4.533s26.083-8.16 32.373-29.013c2.821-9.383 1.023-13.454-1.826-15.105a6.038 6.038 0 0 0-7.854 1.844 5.942 5.942 0 0 0-1.02 2.717Z"
      fill="#fff"
    />
    <path
      d="m232.534 30.635 4.483 5.43 3.944-4.206-7.075-6.238-1.352 5.014Z"
      fill="#F4A28C"
    />
    <path
      d="M229.375 20.662a4.198 4.198 0 0 0-2.046.193 4.164 4.164 0 0 0-2.655 2.951 4.115 4.115 0 0 0 .036 2.042c.831 3.173 2.62 7.498 6.035 6.01 5.213-2.266 2.474-9.066 2.474-9.066a7.638 7.638 0 0 0-3.844-2.13Z"
      fill="#F4A28C"
    />
    <path
      d="m236.304 63.175-8.892 4.533a6.385 6.385 0 0 0-1.981 1.593 6.307 6.307 0 0 0-.63 7.165l7.988 13.736 3.89-2.72-4.565-12.53a1.56 1.56 0 0 1 .511-1.78c.175-.137.377-.234.593-.287l8.865-2.149-1.579 4.171a8.682 8.682 0 0 0 .913 7.96l8.216 12.168 3.113-1.895-3.953-10.78a6.842 6.842 0 0 1-.287-3.698 6.875 6.875 0 0 1 1.684-3.31l4.282-4.66-18.168-7.517Z"
      fill="#24285B"
    />
    <path d="M322.45 173.842h-53.407v33.546h53.407v-33.546Z" fill="#F2F2F2" />
    <path
      opacity={0.08}
      d="M269.179 173.842h-8.682v20.581h8.682v-20.581Z"
      fill="#000"
    />
    <path
      d="M222.72 21.813s-1.443 4.606 3.579 3.473c5.021-1.134 4.637-2.72 4.637-2.72s.384 5.44 2.894 4.234c2.511-1.206 1.069-4.17 0-6.202-1.068-2.03-1.698-2.638-4.564-2.937-2.867-.3-6.19 1.36-6.546 4.152Z"
      fill="#24285B"
    />
    <path
      d="M231.019 25.74s-.21-1.551 1.296-1.252c1.506.3.913 2.457 0 2.611-.913.154-1.296-1.36-1.296-1.36ZM98.669 143.614l2.236 6.663-5.304 3.346-1.917-11.551 4.985 1.542Z"
      fill="#F4A28C"
    />
    <path
      d="M91.867 135.635a4.159 4.159 0 0 1 1.26-1.614 4.205 4.205 0 0 1 5.651.462c2.255 2.394 4.976 6.211 1.899 8.278-4.72 3.174-9.047-2.72-9.047-2.72a7.52 7.52 0 0 1 .237-4.406Z"
      fill="#F4A28C"
    />
    <path
      d="M95.319 139.724s-1.215-1.006-1.762.417c-.548 1.424 1.588 2.122 2.227 1.396.64-.725-.465-1.813-.465-1.813Z"
      fill="#F4A28C"
    />
    <path
      d="m236.067 34.914 4.894-3.055s15.894-5.395 20.915-.435c5.021 4.96 5.377 23.672-7.404 39.267l-18.167-7.516s.365-8.976-2.657-11.243c-3.022-2.266-6.738-9.066 2.419-17.018ZM233.703 89.522s-.996 4.588.785 4.425c1.78-.163 2.191-6.51 2.191-6.51l-2.976 2.085ZM249.725 94.826s-.996 4.579.785 4.425c1.78-.154 2.182-6.51 2.182-6.51l-2.967 2.085Z"
      fill="#007AFF"
    />
    <path
      d="M274.941 67.554s-3.068 1.315-1.936 2.82c1.132 1.505 5.012-.526 5.012-.526l.238-2.294h-3.314ZM206.104 80.084s-5.039.408-3.98 1.56a5.419 5.419 0 0 0 1.917 1.46s-3.652 4.052-.995 4.859c2.657.807 5.25-4.243 5.25-4.243l-2.192-3.636Z"
      fill="#F4A28C"
    />
    <path
      d="m216.442 77.73-89.027 40.806 16.296 35.064 89.027-40.806-16.296-35.065Z"
      fill="#FFD200"
    />
    <path
      opacity={0.58}
      d="m209.119 92.182-42.722 19.497 2.668 5.767 42.722-19.497-2.668-5.767ZM214.643 104.132l-42.722 19.496 2.668 5.767 42.722-19.496-2.668-5.767Z"
      fill="#fff"
    />
    <path
      d="M153.729 138.654c5.606 0 10.152-4.514 10.152-10.082 0-5.568-4.546-10.082-10.152-10.082-5.607 0-10.152 4.514-10.152 10.082 0 5.568 4.545 10.082 10.152 10.082Z"
      fill="#fff"
    />
    <path
      d="m287.201 184.114-7.121 6.872 7.121 6.882M302.603 184.114l7.121 6.872-7.121 6.882"
      stroke="#A5A5A5"
      strokeWidth={2.03}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity={0.58}
      d="M199.047 58.86s-8.773-2.34-10.663-10.427c0 0 13.557-2.784 14.004 11.124l-3.341-.698Z"
      fill="#007AFF"
    />
    <path
      opacity={0.73}
      d="M200.116 57.989s-6.163-9.584-.813-18.587c0 0 10.344 6.465 5.816 18.587h-5.003Z"
      fill="#007AFF"
    />
    <path
      d="M201.695 57.989s3.186-10.155 12.955-12.122c0 0 1.826 6.582-6.281 12.122h-6.674Z"
      fill="#007AFF"
    />
    <path
      d="m297.673 184.114-6.829 13.754"
      stroke="#A5A5A5"
      strokeWidth={2.03}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity={0.63}
      d="M146.389 91.716H119.63v4.987h26.759v-4.987Z"
      fill="#CECECE"
    />
    <path
      d="M94.414 152.308s-15.675 9.43-17.73 31.552a7.632 7.632 0 0 0 1.4 5.16 7.73 7.73 0 0 0 4.453 3l18.368 4.488-6.49-44.2Z"
      fill="#007AFF"
    />
    <path
      opacity={0.2}
      d="M94.414 152.308s-15.675 9.43-17.73 31.552a7.632 7.632 0 0 0 1.4 5.16 7.73 7.73 0 0 0 4.453 3l18.368 4.488-6.49-44.2Z"
      fill="#fff"
    />
    <path
      d="m195.341 57.79 1.826 12.058h11.183l1.598-12.059h-14.607ZM95.985 137.992s2.502 7.127-1.871 6.682c-4.374-.444-1.973-3.509-4.145-6.682-2.173-3.173-1.023-5.313 2.282-8.096 1.525-1.279 2.547-1.868 3.15-2.548a2.354 2.354 0 0 1 3.935.553c1.132 2.738 1.141 6.401-3.35 10.091Z"
      fill="#24285B"
    />
    <path
      opacity={0.08}
      d="M298.184 102.778h-40.115v62.641h40.115v-62.641Z"
      fill="#000"
    />
    <path
      d="m97.698 177.239-30.268 7.748 5.592 21.546 30.268-7.747-5.592-21.547Z"
      fill="#FFD200"
    />
    <path
      opacity={0.08}
      d="m85.303 180.052 3.47 14.371-.904 7.915 8.116-2.086 2.42-6.419-7.797-15.15-5.305 1.369Z"
      fill="#000"
    />
    <path
      d="M90.79 156.941a12.511 12.511 0 0 1 3.204-4.286 12.624 12.624 0 0 1 4.712-2.568c6.7-2.004 19.427-6.192 23.188 0 5.149 8.523-2.739 41.987-2.739 41.987l-22.522 1.732s-12.425-22.159-5.843-36.865Z"
      fill="#007AFF"
    />
    <path
      d="m119.119 192.102-2.967 38.451h-4.684l-4.181-29.874-10.353-6.846 22.185-1.731Z"
      fill="#24285B"
    />
    <path
      d="m96.934 193.833-6.463 36.72h5.02l10.846-30.5-9.403-6.22Z"
      fill="#24285B"
    />
    <path
      d="M108.447 155.21a6.3 6.3 0 0 1 .897-5.636 6.384 6.384 0 0 1 2.23-1.921 6.42 6.42 0 0 1 2.862-.721c2.866-.091 6.162.399 8.691 2.43 5.633 4.533 24.102 7.616 40.772-7.535l3.204 4.887s-18.934 24.48-48.587 17.444a13.917 13.917 0 0 1-6.083-3.079 13.788 13.788 0 0 1-3.868-5.588c-.045-.091-.082-.191-.118-.281Z"
      fill="#007AFF"
    />
    <path
      opacity={0.2}
      d="M108.447 155.21a6.3 6.3 0 0 1 .897-5.636 6.384 6.384 0 0 1 2.23-1.921 6.42 6.42 0 0 1 2.862-.721c2.866-.091 6.162.399 8.691 2.43 5.633 4.533 24.102 7.616 40.772-7.535l3.204 4.887s-18.934 24.48-48.587 17.444a13.917 13.917 0 0 1-6.083-3.079 13.788 13.788 0 0 1-3.868-5.588c-.045-.091-.082-.191-.118-.281Z"
      fill="#fff"
    />
    <path
      opacity={0.08}
      d="M100.65 149.498s-10.536 33.7 19.884 35.93l-1.415 6.673-22.523 1.732a57.71 57.71 0 0 1-7.605-29.756s.192-8.595 6.29-12.394a13.812 13.812 0 0 1 5.369-2.185Z"
      fill="#000"
    />
    <path
      d="m91.384 230.553-3.114 2.276a.676.676 0 0 0-.003 1.103c.118.085.26.13.405.13h5.222a.7.7 0 0 0 .482-.202.687.687 0 0 0 .203-.478v-2.829h-3.195ZM116.024 230.553l2.93 2.276a.687.687 0 0 1-.429 1.233h-3.716a1.997 1.997 0 0 1-1.401-.583 1.969 1.969 0 0 1-.58-1.394v-1.532h3.196Z"
      fill="#007AFF"
    />
    <path d="M333.552 90.583h-66.307v67.619h66.307V90.583Z" fill="#F2F2F2" />
    <path
      d="M320.076 107.266h-40.854v2.43h40.854v-2.43ZM320.076 122.615h-40.854v2.43h40.854v-2.43ZM320.076 137.965h-40.854v2.43h40.854v-2.43Z"
      fill="#A5A5A5"
    />
    <path
      d="M317.958 102.778h-.009c-1.976 0-3.579 1.591-3.579 3.554v4.297c0 1.963 1.603 3.554 3.579 3.554h.009c1.977 0 3.579-1.591 3.579-3.554v-4.297c0-1.963-1.602-3.554-3.579-3.554Z"
      fill="#24285B"
    />
    <path
      d="M301.772 118.127h-.009c-1.977 0-3.579 1.592-3.579 3.554v4.298c0 1.963 1.602 3.554 3.579 3.554h.009c1.976 0 3.579-1.591 3.579-3.554v-4.298c0-1.962-1.603-3.554-3.579-3.554Z"
      fill="#007AFF"
    />
    <path
      d="M290.816 133.486h-.009c-1.976 0-3.579 1.591-3.579 3.554v4.298c0 1.963 1.603 3.554 3.579 3.554h.009c1.977 0 3.579-1.591 3.579-3.554v-4.298c0-1.963-1.602-3.554-3.579-3.554Z"
      fill="#FFD200"
    />
    <path d="M248.045 161.865h-74.834v16.936h74.834v-16.936Z" fill="#fff" />
    <path d="M248.045 161.865h-25.517v16.936h25.517v-16.936Z" fill="#24285B" />
    <path
      d="M166.264 145.454s3.907 1.269 4.738-4.443l-6.637 1.551 1.899 2.892Z"
      fill="#F4A28C"
    />
    <path
      opacity={0.08}
      d="M243.791 66.267s7.942-1.505 10.681-12.385c2.739-10.88-3.095-19.52 2.538-20.853 5.633-1.333 7.97 12.856 7.97 12.856s.219 11.097-10.508 24.824l-10.681-4.442Z"
      fill="#000"
    />
    <path
      d="M260.662 30.454c4.674 1.65 11.978 4.932 16.908 10.49a14.476 14.476 0 0 1 3.034 5.463c.601 2.018.752 4.142.444 6.224l-2.209 14.923h-5.25l.237-13.6a6.657 6.657 0 0 0-1.295-4.001 6.733 6.733 0 0 0-3.443-2.445c-5.669-1.723-14.369-5.549-14.379-12.802a4.426 4.426 0 0 1 1.861-3.666 4.503 4.503 0 0 1 4.092-.586Z"
      fill="#007AFF"
    />
    <path
      opacity={0.2}
      d="M260.662 30.454c4.674 1.65 11.978 4.932 16.908 10.49a14.476 14.476 0 0 1 3.034 5.463c.601 2.018.752 4.142.444 6.224l-2.209 14.923h-5.25l.237-13.6a6.657 6.657 0 0 0-1.295-4.001 6.733 6.733 0 0 0-3.443-2.445c-5.669-1.723-14.369-5.549-14.379-12.802a4.426 4.426 0 0 1 1.861-3.666 4.503 4.503 0 0 1 4.092-.586Z"
      fill="#fff"
    />
    <path
      opacity={0.08}
      d="M247.725 149.498h-34.08v4.116h34.08v-4.116Z"
      fill="#000"
    />
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          transform="translate(0 43.734)"
          d="M0 0h382.672v179.309H0z"
        />
      </clipPath>
    </defs>
  </svg>
)

export default NoLinks;
